import Fuse from 'fuse.js'

const campaignOptions = {
  shouldSort: true,
  matchAllTokens: true,
  threshold: 0.2,
  maxPatternLength: 32,
  minMatchCharLength: 3,
  keys: ['name', 'menuName', 'advertiserName', 'insertionOrderName'],
}

export const campaignSearch = ({ items }) => {
  return new Fuse(items, campaignOptions)
}

export default campaignSearch
